import React,{useState, useEffect} from "react";
import Logo from "../header/Logo";
import Menu from "../header/Menu";

const Header=()=>{

    const [scrollPosition, setScrollPosition] = useState(0); //스크롤 위치변수선언
    const updateScroll =() =>{
        setScrollPosition(window.scrollY || document.documentElement.scrollTop);
    }; //스크롤 Y값을 추출

    useEffect(()=>{
        window.addEventListener('scroll',updateScroll);
    }); 

    return(
        
        <header id={scrollPosition < 100 ? "header_ori":"header_cha"} role={scrollPosition < 100 ? "header_ori":"header_cha"}>
            <div className="header">
                <Logo y={scrollPosition}/>
                <Menu y={scrollPosition}/>
                
            </div>
        </header>
    )
}

export default Header;